import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import AdminMenuWrapper from '@admin/nav_menu/AdminMenuWrapper';
import { Switcher, BasicButton, BasicText } from '@components';
import LoadingWrapper from '@components/LoadingWrapper';
import OverallStats from '@users/OverallStats';
import UserTable from '@users/UserTable';
import { getAPIRequest, postAPIRequest } from '@actions';
import styles from './GroupHome.module.css';
import { Input, Space } from 'antd';
import GroupTable from './GroupTable';
import { ConfirmModal } from '@components';

const { Search } = Input;

let _searchTimeout = null;

const GroupHome = ({ getAPIRequest, postAPIRequest }) => {
  const [isSearching, setIsSearching] = useState(false);
  const [overallData, setOverallData] = useState({});
  const [groups, setGroups] = useState([]);
  const [seenIds, setSeenIds] = useState([]);
  const [searchGroups, setSearchGroups] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isMore, setIsMore] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [selectedGroupDelete, setSelectedGroupDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    getAPIRequest(
      '/admin/get_group_data',
      {},
      response => {
        setGroups(response.groups);
        setSeenIds(response.groups.map((u) => u.id));
        setOverallData(response.overall_stats);
        setIsLoading(false);
      },
      error => {
        //onFail(error.error);
      },
    )
  };

  const performSearch = () => {
    const currentSearchTerm = searchTerm;
    if (currentSearchTerm.length > 0) {
      getAPIRequest(
        '/admin/search_groups',
        { query: currentSearchTerm },
        response => {
          if (currentSearchTerm === searchTerm) {
            setSearchGroups(response.groups);
          }
        },
        error => {
          //onFail(error.error);
        },
      );
    }
  }

  useEffect(() => {
    clearTimeout(_searchTimeout);
    if (searchTerm.length > 0) {
      _searchTimeout = setTimeout(() => performSearch(), 500);
    }
  }, [searchTerm]);

  const fetchMoreGroups = () => {
    setIsFetchingMore(true);
    getAPIRequest(
      '/admin/fetch_more_groups',
      { seen_ids: seenIds },
      response => {
        const newGroups = response.groups;
        setIsFetchingMore(false);
        setIsMore(newGroups.length > 0);
        setGroups(groups.concat(newGroups));
        setSeenIds(seenIds.concat(newGroups.map((u) => u.id)));
      },
      error => {
        //onFail(error.error);
      },
    )
  };

  const onDeleteConfirm = () => {
    setDeleteLoading(true);
    postAPIRequest(
      '/admin/delete_group',
      { group_id : selectedGroupDelete.id },
      response => {
        setSelectedGroupDelete(null);
        setDeleteLoading(false);
        setGroups([]);
        setSearchGroups([]);
        setSeenIds([]);
        setIsMore(true);
        setOverallData({});
        setIsLoading(true);
        fetchData();
      },
      error => {

      },
    );
  }

  return (
    <AdminMenuWrapper>
      <LoadingWrapper isLoading={isLoading} loadingText="Fetching Group Data" size="large">
        <div className={styles.user_container_style}>
          <OverallStats overallData={overallData} isGroups />
          <div style={{ padding: 20 }}>
            <Search
              allowClear
              placeholder="Search Groups..."
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
              style={{ width: 360 }}
            />
          </div>

          <GroupTable
            groups={searchTerm.length > 0 ? searchGroups : groups}
            onDeleteGroup={(group) => setSelectedGroupDelete(group)}
          />

          {isMore && searchTerm.length === 0 &&
            <BasicButton
              text="Load More Groups"
              type="primary"
              style={{ marginLeft: "20px", marginTop: "12px", marginBottom: "20px", width: "300px" }}
              loading={isFetchingMore}
              onClick={() => fetchMoreGroups()}
            />
          }

          {selectedGroupDelete != null &&
            <ConfirmModal
              title={"Confirm Delte Group"}
              visible={selectedGroupDelete != null}
              loading={deleteLoading}
              onCancel={() => setSelectedGroupDelete(null)}
              onSubmit={() => onDeleteConfirm()}
            >
              <BasicText marginBottom="20px">
                Are you sure you want to delete the group {selectedGroupDelete.name}?
              </BasicText>
            </ConfirmModal>
          }

        </div>
      </LoadingWrapper>
    </AdminMenuWrapper>
  );
};


export default connect(null, {
  getAPIRequest,
  postAPIRequest
})(GroupHome);
